<template>
	<div class="information">
		<leftnav class="fl" mkcode="B" itemcode="B-DTJC"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox information_box1">
					<div class="opport-screen-list2 oh">
						<span class="inkeyName">{{ keyname }}</span>
					</div>
					<ul class="information_content">
						<li class="infornews" v-for="(list,i) in listdata" :key="'list'+i">
							<div @click="routerlinkid('/informationdetail', list.id, 1)" class="infornews_d">
								<h5 class="title"><span class="fl info_title">{{ list.title }}</span><span class="fr">{{
									list.publishTime }}</span></h5>
								<p>{{ list.summary }}</p>
							</div>
							<div class="keywords" v-show="list.keylist.length > 0">
								<span v-for="(item,i) in list.keylist" :key="'key'+i" @click="tagrouter('/timeinforKey', 7, 'news', item.id, item.name)">{{ item.name}}</span>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'information',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			userdata: {}, title: "招商情报-关键词搜索",
			meunlist: [
				{ notion: '高端装备', notioncode: 'A01' },
				{ notion: '汽车产业', notioncode: 'A02' },
				{ notion: '新一代信息技术', notioncode: 'A03' },
				{ notion: '新材料', notioncode: 'A04' },
				{ notion: '新能源', notioncode: 'A05' },
				{ notion: '生物医药', notioncode: 'A06' },
				{ notion: '环保', notioncode: 'A07' },],
			meunindex: 0,
			keyid: 1, keyname: "",
			listdata: [],
		}
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		this.userdata = this.getuserinformain();
		this.keyid = this.$route.query.id;
		this.keyname = this.$route.query.keyword;
	},
	mounted() {
		document.getElementById('app').style.background = "#f0f3f5";
		this.bus.$emit('loading', true);
		if (this.userdata.edition < 1) {
			var _this = this;
			alert('升级版本后即可查看本页面,自动跳转');
			setTimeout(function () {
				_this.routerself('/totalEnterprises');
			}, 1000)
			return;
		}
		this.getlist('A01');
	},
	methods: {
		getlist(notioncode) {
			console.log(notioncode);
			var _this = this;
			// this.bus.$emit('loading', true);
			var ajaxurl = this.$api.cyl.OCNNews.list() + '?keywords=' + this.keyid;
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				// console.log(res);
				if (res.data.success) {
					console.log(ajaxurl);
					_this.listdata = res.data.list;
					for (var i = 0; i < res.data.list.length; i++) {
						_this.listdata[i].keylist = _this.taglistfun(res.data.list[i].keywordsText, res.data.list[i].keywords);
					}
					console.log(_this.listdata)
					_this.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) {
				_this.bus.$emit('loading', false);
				// 请求失败处理 console.log(error);
			});
		},
		keycodetoggle(id) {
			this.keyid = id;
		}


	},
}
</script>

<style></style>
